import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2294_10003)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M24 12.9224C24 6.29494 18.6274 0.922363 12 0.922363C5.37258 0.922363 0 6.29494 0 12.9224C0 18.9118 4.3882 23.8763 10.125 24.7766V16.3911H7.07812V12.9224H10.125V10.2786C10.125 7.27111 11.9166 5.60986 14.6576 5.60986C15.9701 5.60986 17.3438 5.84424 17.3438 5.84424V8.79736H15.8306C14.34 8.79736 13.875 9.72244 13.875 10.6724V12.9224H17.2031L16.6711 16.3911H13.875V24.7766C19.6118 23.8763 24 18.9118 24 12.9224Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2294_10003",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.922363)"
		})
	}) })]
});
export default SvgFacebook;
